/* Components */
import Header from "../../components/common/Header";
import Icon from "../../components/common/Icon";
import GalleryHeader from "../../components/common/GalleryHeader";
import {useEffect, useState} from "react";
import {getAgencyHeader} from "../../api/pro/agencyReq";
import useAuth from "../../hooks/useAuth";
import {
    deleteMediaFromDb, getGalleryCategoryList,
    getGalleryContent,
    getGalleryHeaderList,
    uploadMediaPositionDown,
    uploadMediaPositionUp
} from "../../api/pro/galleryMediaSiteReq";
/* External libs */
import jwt_decode from "jwt-decode";
import FormEditMedium from "../../forms/tools/FormEditMedium";
import useData from "../../hooks/useData";


export default function GalleryMedia() {
    const sources = [ "fa fa-photo-film" ];
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = jwt_decode(token);
    const agencyId = decodedToken.agency;
    const [ agencyHeader, setAgencyHeader ] = useState();
    const [ galleryHeaderList, setGalleryHeaderList ] = useState([]);
    const [ galleryCategoryList, setGalleryCategoryList ] = useState([]);
    const { galleryContent, setGalleryContent } = useData();
    const [ categoryId, setCategoryId ] = useState();
    const [ categoryName, setCategoryName ] = useState();
    const [ headerId, setHeaderId ] = useState();
    const [ mediaId, setMediaId ] = useState();
    const IMG_FOLDER = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;
    const [ showModalNew, setShowNewModal ] = useState(false);
    const [ showModalEdit, setShowEditModal ] = useState(false);
    const [ totalMediaCount, setTotalMediaCount ] = useState();

    const apiAgencyHeader = async () => {
        const response = await getAgencyHeader(token, agencyId)
        setAgencyHeader(response)
    };

    const apiGalleryCategoryList = async () => {
        const response = await getGalleryCategoryList(token)
        setGalleryCategoryList(response)
    }

    const apiGalleryHeaderList = async () => {
        const response = await getGalleryHeaderList(token)
        setGalleryHeaderList(response)
    }

    const apiGalleryContent = async () => {
        const response = await getGalleryContent(token, agencyId)
        setGalleryContent(response)
    }

    const handleAddMedium = (categoryId, categoryName, headerId) => {
        setCategoryId(categoryId);
        setCategoryName(categoryName);
        setHeaderId(headerId);
        setShowNewModal(true)
    }

    const handleFormEditMedium = (mediaId,  headerId, categoryId, categoryName,) => {
        setCategoryId(categoryId);
        setCategoryName(categoryName);
        setHeaderId(headerId);
        setMediaId(mediaId);
        setShowEditModal(true)
    }

    useEffect(() => {
        setTotalMediaCount(galleryContent?.length)
    }, [ galleryContent ]);

    const handleMediaUp = async (id) => {
        await uploadMediaPositionUp(token, id)
        await apiGalleryContent()
        await apiGalleryHeaderList()
    }

    const handleMediaDown = async (id) => {
        await uploadMediaPositionDown(token, id)
        await apiGalleryContent()
        await apiGalleryHeaderList()
    }

    const handleDeleteMedia = async (id) => {
        if (window.confirm("Voulez-vous vraiment supprimer ce media ?")) {
            let body = {
                mediaId: id,
                agencyId: agencyId
            }
            await deleteMediaFromDb(token, body)
            await apiGalleryContent()
            await apiGalleryHeaderList()
        }
    }

    useEffect(() => {
        apiAgencyHeader()
        apiGalleryHeaderList()
        apiGalleryContent()
    }, [ agencyId ]);

    useEffect(() => {
        apiGalleryCategoryList()
    }, [ token]);

    return (
        <main>
            <Header
                location="Galerie photos et vidéos"
                parent="Tableau de bord"
                slug="/"
            />
            { showModalNew &&
                <div className="modal new-medium">
                    <FormEditMedium apiGalleryContent={apiGalleryContent} apiGalleryHeaderList={apiGalleryHeaderList} setShowModal={setShowNewModal} headerId={headerId} categoryId={categoryId} legend={`Création d'un média dans : ${categoryName}`} />
                </div>
            }
            { showModalEdit &&
                <div className="modal edit-medium">
                    <FormEditMedium apiGalleryContent={apiGalleryContent} apiGalleryHeaderList={apiGalleryHeaderList} setShowModal={setShowEditModal} mediaId={mediaId} headerId={headerId} categoryId={categoryId} legend={`Modification d'un média dans : ${categoryName}`} />
                </div>
            }
            <div className="content-container">
                <Icon source="fa fa-photo-film" color="blue" span="Gestion des médias du site"/>
                <div className="dashboard media">
                    <div className="gallery">
                        {/*<GalleryHeader data={agencyHeader}/>*/}
                        <div className="flex-buttons">
                            { galleryCategoryList?.map((category, index) => {
                                // Vérifier si cette catégorie existe déjà dans la galerie
                                const existingHeader = galleryHeaderList?.find(
                                    header => header?.categoryId == category?.id
                                );

                                return (
                                    <button className="green-button"
                                        key={index}
                                        onClick={() => handleAddMedium(
                                            category?.id,
                                            category?.name,
                                            existingHeader?.id || 0)}>
                                        <i className="fa fa-plus"/><span>{category?.name}</span>
                                    </button>
                                );
                            })}
                        </div>
                        <h3>Galerie Photos et Vidéos (<span>{totalMediaCount}</span> / 60)</h3>
                        { galleryHeaderList?.map((header, index) => {
                            const headerMediaList = galleryContent?.filter(content => content?.headerId === header?.id) || [];
                            return (
                            <div key={header?.id} className="media-group">
                                {/* Desktop : tableau classique (masqué en mobile, cf. _gallery.scss). */}
                                <table className="media-table desktop-only">
                                    <thead className="dashboard-header">
                                        <tr>
                                            <th>{header?.categoryName}</th>
                                            <th><span>Nb photos = {header?.nbPhoto}</span> <span>Nb vidéos = {header?.nbVideo}</span></th>
                                            <th><i className="fa fa-gear"/></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {headerMediaList.map((media, mediaIndex) => (
                                        <tr className="category-content" key={media?.id}>
                                            <td>
                                                {media?.name?.endsWith('.mp4') ? (
                                                    <video width="200" controls>
                                                        <source src={`${IMG_FOLDER}/media/galery/${agencyId}/${media?.name}`} type="video/mp4"/>
                                                        Votre navigateur ne supporte pas la lecture de vidéos.
                                                    </video>
                                                ) : (
                                                    <img src={`${IMG_FOLDER}/media/galery/${agencyId}/${media?.name}`} alt="Media de l'agence"/>
                                                )}
                                            </td>
                                            <td className="media-infos">
                                                <p>
                                                    <span>{media?.description}</span>
                                                    <span>{media?.salesInfos}</span>
                                                </p>
                                            </td>
                                            <td>
                                                <div className="actions">
                                                    <i className="fa fa-pen-to-square" onClick={
                                                        () => handleFormEditMedium(
                                                            media?.id,
                                                            header?.id,
                                                            header?.categoryId,
                                                            header?.categoryName
                                                        )}
                                                    />
                                                    <i className="fa fa-trash" onClick={() => handleDeleteMedia(media?.id)}/>
                                                </div>

                                                <div className="up-down-section">
                                                    {/* Masquées (plutôt que grisées) aux extrémités : rien à
                                                        faire remonter/descendre pour le premier/dernier élément. */}
                                                    {mediaIndex !== headerMediaList.length - 1 &&
                                                        <i className="fa fa-arrow-down" onClick={() => handleMediaUp(media?.id)}/>
                                                    }
                                                    {mediaIndex !== 0 &&
                                                        <i className="fa fa-arrow-up" onClick={() => handleMediaDown(media?.id)}/>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan="3">
                                                <button className="add-media-min"
                                                    onClick={() => handleAddMedium(
                                                        header?.categoryId,
                                                        header?.categoryName,
                                                        header?.id)}>
                                                    +
                                                </button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>

                                {/* Mobile : cartes (masquées en desktop, cf. _gallery.scss). On évite de
                                    convertir le <table> en flex en mobile : cette approche a été tentée et
                                    abandonnée (colonnes fantômes persistantes héritées du thead quel que
                                    soit le display forcé sur tbody/tr), cf. même constat déjà fait sur le
                                    tableau de modération des condoléances. */}
                                <div className="media-cards mobile-only">
                                    <div className="media-cards-header">
                                        <span className="category-name">{header?.categoryName}</span>
                                        <span className="counts">Nb photos = {header?.nbPhoto} / Nb vidéos = {header?.nbVideo}</span>
                                        <i className="fa fa-gear"/>
                                    </div>
                                    { headerMediaList.map((media, mediaIndex) => (
                                        <div className="media-card" key={media?.id}>
                                            <div className="media-card-top">
                                                <div className="media-card-media">
                                                    {media?.name?.endsWith('.mp4') ? (
                                                        <video width="200" controls>
                                                            <source src={`${IMG_FOLDER}/media/galery/${agencyId}/${media?.name}`} type="video/mp4"/>
                                                            Votre navigateur ne supporte pas la lecture de vidéos.
                                                        </video>
                                                    ) : (
                                                        <img src={`${IMG_FOLDER}/media/galery/${agencyId}/${media?.name}`} alt="Media de l'agence"/>
                                                    )}
                                                </div>
                                                <div className="media-card-infos">
                                                    <span>{media?.description}</span>
                                                    <span>{media?.salesInfos}</span>
                                                </div>
                                            </div>
                                            <div className="media-card-actions">
                                                <i className="fa fa-pen-to-square" onClick={
                                                    () => handleFormEditMedium(
                                                        media?.id,
                                                        header?.id,
                                                        header?.categoryId,
                                                        header?.categoryName
                                                    )}
                                                />
                                                <i className="fa fa-trash" onClick={() => handleDeleteMedia(media?.id)}/>
                                                {mediaIndex !== headerMediaList.length - 1 &&
                                                    <i className="fa fa-arrow-down" onClick={() => handleMediaUp(media?.id)}/>
                                                }
                                                {mediaIndex !== 0 &&
                                                    <i className="fa fa-arrow-up" onClick={() => handleMediaDown(media?.id)}/>
                                                }
                                            </div>
                                        </div>
                                    ))}
                                    <button className="add-media-min"
                                        onClick={() => handleAddMedium(
                                            header?.categoryId,
                                            header?.categoryName,
                                            header?.id)}>
                                        +
                                    </button>
                                </div>
                            </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </main>
    )
}